// App utils
import { datajsAll } from '../shared/utils';

export default class AdTracking {
	static init() {
		const ads = datajsAll('journalisten-ad');

		const handleAdClick = function (event) {
			const ad = event.currentTarget;
			const category = ad.dataset?.category || 'ingen kategori';
			const label = ad.dataset?.label || 'inget namn';

			window.dataLayer = window.dataLayer || [];

			window.dataLayer.push({
				event: 'eventTracking',
				category: category,
				action: 'ad-click',
				label: label,
			});
		};

		// Show off canvas menu
		if (ads) {
			ads.forEach((ad) => {
				ad.addEventListener('click', handleAdClick);
			});
		}
	}
}
